import { i18n as I18n, PostProcessorModule, TOptions } from 'i18next';
import { recordUsedTranslation } from 'Douleutaras/services/requestContext';

export interface SsrTranslations {
  lng: string;
  resources: Record<string, string>;
}

interface ResolvedTranslation {
  res?: unknown;
  exactUsedKey?: string;
}

export const SSR_TRANSLATIONS_POST_PROCESSOR = 'ssrTranslations';

// postProcessPassResolved hands over the raw string, before interpolation
export const ssrTranslationsPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: SSR_TRANSLATIONS_POST_PROCESSOR,
  process(value: string, _key: string, options: TOptions & { i18nResolved?: ResolvedTranslation }): string {
    const resolved = options.i18nResolved;
    if (typeof resolved?.res === 'string' && resolved.exactUsedKey) {
      recordUsedTranslation(resolved.exactUsedKey, resolved.res);
    }

    return value;
  }
};

// Turns the recorder on for one request's i18n clone
export const SSR_TRANSLATIONS_CLONE_OPTIONS = {
  postProcess: [SSR_TRANSLATIONS_POST_PROCESSOR],
  postProcessPassResolved: true
};

export const readSsrTranslations = (): SsrTranslations | undefined =>
  (window as Window & { _SSR_TRANSLATIONS?: SsrTranslations })._SSR_TRANSLATIONS;

// Overwrites cached copies too: hydration must see exactly the server's text
export const seedSsrTranslations = (i18n: I18n, ssrTranslations: SsrTranslations | undefined, lng?: string): void => {
  if (ssrTranslations && ssrTranslations.lng === lng?.toLowerCase()) {
    i18n.addResourceBundle(ssrTranslations.lng, 'translation', ssrTranslations.resources, true, true);
  }
};
